<template>
  <div>
    <div class="popupImpowerLogin" v-if="ImpowerLoginShow">
          <div class="maskWin">
          </div>
            <div class="popupImpowerLoginAll" :style="{width:(stateImpowerLogin?'832px':'1080px'),height:(stateImpowerLogin?'452px':'561px')}" >
              <div class="popupImpowerHeadline">
                <!-- <div style="padding-left:20px"></div> -->
                <div v-if="!stateImpowerLogin" style="cursor: pointer;" @click="closeImpowerLogin"><img  class="popupImpowerClosebannerImg" src="https://imagecdn.ymm56.com/ymmfile/static/resource/79787d2b-21f5-45c0-ae79-be3d7fcbddd8.png" alt=""></div>
              </div>
                <div class="popupImpowerLoginTitle">
                  <!--  -->
                  <span v-if="!stateImpowerLogin">
                    《用户服务协议》《隐私政策》修订公示
                  </span>
                  <span v-if="stateImpowerLogin">
                    《用户服务协议》《隐私政策》更新提示
                  </span>
                  
                </div>
                <div  class="popupImpowerLoginContent" v-if="stateImpowerLogin">
                  <div style="font-weight: bold;">
                    尊敬的蓝桥TMS用户：
                  </div>
                  <br>
                  <div style="padding-left: 10px;">
                    &nbsp;&nbsp;感谢您信任并使用蓝桥的产品和服务，为了更好地维护您的利益，我们对
                    <span style="color: blue;cursor: pointer;" @click="getUserServiceAgreement">《用户服务协议》</span> <span style="color: blue;cursor: pointer;" @click="getPrivacyAgreement">《隐私政策》</span>
                    进行了更新，特按照《个人信息保护法》等法律法规要求向您推送本提示。请您仔细阅读并充分理解相关条款。
                  </div>
                  <br>
                  <div style="padding-left: 10px;">
                    &nbsp;&nbsp;您点击"同意”，即表示您已阅读并同意更新后的
                    <span @click="getUserServiceAgreement" style="color: blue;cursor: pointer;">《用户服务协议》</span> <span style="color: blue;cursor: pointer;" @click="getPrivacyAgreement">《隐私政策》</span>
                    ，蓝桥将尽全力保障您的合法权益。
                  </div>
                  <div style="padding-top:100px;" class="popupImpowerLoginContentDutton">
                    <el-button type="info" @click="exitLogin" >不同意并退出</el-button>
                    <el-button style="margin-left: 40px;" type="primary" @click="consentLogin">同意</el-button>
                  </div>
                </div>
                <div class="popupImpowerLoginContent" v-if="!stateImpowerLogin">
                  <div style="font-weight: bold;">尊敬的蓝桥TMS用户：</div>
                   <div>&nbsp;&nbsp;为营造良好的交易环境和交易秩序，保障平台用户合法权益，蓝桥对  <span style="color: blue;cursor: pointer;" @click="getUserServiceAgreement">《用户服务协议》</span> <span style="color: blue;cursor: pointer;" @click="getPrivacyAgreement">《隐私政策》</span>进行了优化调整。</div>
                   <br>
                   <div>&nbsp;&nbsp; 主要优化点如下：</div>&nbsp;&nbsp; 5.8您理解并同意，为便于您的客户能够快速知晓运输状态，蓝桥为您提供“蓝桥查单”技术服务功能，您的客户可通过蓝桥专线帮小程序、公众号推送、短信的方式获取运单节点信息并知晓货物运输状态。在您使用服务过程中，我们会向您的客户发送短信告知查单路径，并将您录入在蓝桥系统中的运单相关信息（具体包括运单日期、货物信息、发货/收货地、经由地、承运专线名称、承运相关人员车牌号、运输状态、承运相关人员及车辆轨迹定位、以及其他运单和运输相关信息）提供给货主和/或收货方。如您希望关闭“蓝桥查单”功能，可拨打蓝桥客服电话。
                   <br>
                   <div>&nbsp;&nbsp; 一、《用户服务协议》第5.8条增加“蓝桥查单”技术服务条款： </div>
                   <br>
                   <div style="font-weight: bold;">&nbsp;&nbsp;5.8您理解并同意，为便于您的客户能够快速知晓运输状态，蓝桥为您提供“蓝桥查单”技术服务功能，您的客户可通过蓝桥专线帮小程序、公众号推送、短信的方式获取运单节点信息并知晓货物运输状态。在您使用服务过程中，我们会向您的客户发送短信告知查单路径，并将您录入在蓝桥系统中的运单相关信息（具体包括运单日期、货物信息、发货/收货地、经由地、承运专线名称、承运相关人员车牌号、运输状态、承运相关人员及车辆轨迹定位、以及其他运单和运输相关信息）提供给货主和/或收货方。如您希望关闭“蓝桥查单”功能，可拨打蓝桥客服电话。</div>
                   <br>
                   <div>&nbsp;&nbsp;二、《隐私政策》新增第1.2.6条 查单功能条款</div>
                   <br>
                   <div>
                       为便于您的客户（例如托运人/货主）能够快速知晓运输状态，我们提供查单功能，我们将收集您录入的您客户的手机号信息以和您客户在蓝桥专线帮小程序注册手机号匹配后通过蓝桥专线帮小程序、公众号推送、短信的方式获取您在蓝桥录入的该手机号下的全部的运单信息（包括运输中的货物以及运输完成的货物）。为提供该服务，<span style="font-weight: bold;">我们还将收集您输入的全部相关信息，包括运单日期、货物信息、发货/收货地、经由地、承运专线名称、承运相关人员车牌号、运输状态、承运相关人员及车辆轨迹定位、其他运单和运输相关信息。如您希望关闭“蓝桥查单”功能，可通过400-8303721蓝桥客服电话联系我们以关闭。</span>
                   </div>
                   <br>
                   <div style="font-weight: bold;">
                    更新后的具体内容请点击 <span @click="getUserServiceAgreement" style="color: blue;text-decoration: underline;cursor: pointer;">《用户服务协议》</span><span @click="getPrivacyAgreement" style="color: blue;text-decoration: underline;cursor: pointer;">《隐私政策》</span>查看。
                   </div>
                   <br>
                   <div>
                    &nbsp;&nbsp; <span @click="getUserServiceAgreement" style="color: blue;text-decoration: underline;cursor: pointer;">《用户服务协议》</span><span @click="getPrivacyAgreement" style="color: blue;text-decoration: underline;cursor: pointer;">《隐私政策》</span>将于2024年5月06日起进行公示，除另行发出书面公告外，将于公示期届满次日起（即2024年5月13日00：00）生效。
                   </div>
                   <br>
                   <div>
                     若您继续使用蓝桥TMS服务，将被视为已充分阅读、理解并接受 <span @click="getUserServiceAgreement" style="color: blue;text-decoration: underline;cursor: pointer;">《用户服务协议》</span><span @click="getPrivacyAgreement" style="color: blue;text-decoration: underline;cursor: pointer;">《隐私政策》</span>内容，将对您产生法律约束力。
                   </div>
                   <br>
                   <div>
                    特此通知，敬请知悉！ 
                   </div>
        

                      <!-- <div class="popupImpowerLoginContentRight"> -->
                        <div style="text-align: right;">
                          广州市蓝桥技术服务有限公司
                        </div>
                        
                      <!-- </div> -->
                      <!-- <div  class="popupImpowerLoginContentRight"> -->
                        <div style="text-align: right;">
                          2024年5月6日
                        </div>
                       
                      <!-- </div> -->
        
                </div>
            </div>
      </div>
      <UserServiceAgreement ref="UserServiceAgreement" />
      <PrivacyAgreement ref="PrivacyAgreement" />
  </div>
</template>
<script>
  import UserServiceAgreement from '@/components/home/UserServiceAgreement.vue'
  import PrivacyAgreement from '@/components/home/PrivacyAgreement.vue'
  import Vue from 'vue';
  export default {
      data () {
      return {
        stateImpowerLogin:false,
        ImpowerLoginShow:false,
      }
    },
    components: {
      UserServiceAgreement,
      PrivacyAgreement,
    },
    mounted() {
      $.javaAjax({
          // url: "/special-line-help/is-grey-user",
          url: "/special-line-help/is-popup-grey-user",
          type: "POST",
          success:  (result) =>{
            if (result.success&& result.data) {
                $.javaAjax({
                  url: "/special-line-help/is-authorization",
                  type: "POST",
                  success:  (result)  =>{
                    if(result.success&& result.data===false){
                      this.ImpowerLoginShow=true
                      this.stateImpowerLogin=true
                    }
                  },
                })
            }
           },
        })
    },
    methods:{
      getPrivacyAgreement(){
        this.$refs.PrivacyAgreement.PrivacyAgreementShow=true
      },
      getUserServiceAgreement(){
        this.$refs.UserServiceAgreement.UserServiceAgreementShow=true
      },
      privacyShow(){
        this.ImpowerLoginShow=true
        this.stateImpowerLogin=false
      },  
      closeImpowerLogin(){
        this.ImpowerLoginShow=false
        this.stateImpowerLogin=false
      },
      exitLogin(){
         top.logoutWeb();
      },
      consentLogin(){
        function formatEncrypt(dat){
            //获取年月日，时间
            var year = dat.getFullYear();
            var mon = (dat.getMonth()+1) < 10 ? "0"+(dat.getMonth()+1) : dat.getMonth()+1;
            var data = dat.getDate()  < 10 ? "0"+(dat.getDate()) : dat.getDate();
            var hour = dat.getHours()  < 10 ? "0"+(dat.getHours()) : dat.getHours();
            var min =  dat.getMinutes()  < 10 ? "0"+(dat.getMinutes()) : dat.getMinutes();
            var seon = dat.getSeconds() < 10 ? "0"+(dat.getSeconds()) : dat.getSeconds();
                
            var newDate = year +"-"+ mon +"-"+ data +" "+ hour +":"+ min +":"+ seon;
            return newDate;
        }
        let baseUrlPar= window.location.host=='t9bs-dev.lqfast.com' || window.location.host=='localhost:4585'?'https://internal-marketing-dev.lqfast.com':'https://internal-marketing.lqfast.com';
            // 加密
            let encrypt1 = function (word) {
                if (!word) return;
                let key = CryptoJS.enc.Utf8.parse('xfwapi*#$1008656');
                let ivs = CryptoJS.enc.Utf8.parse('yxfwapims*@#5656');
                let encryptedData = CryptoJS.AES.encrypt(word, key, {
                    iv: ivs,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                });
                return encryptedData.toString();
            }
            let DatePar1=[
                {
                    ParamterName:"status",
                    Value:"0"
                },
                {
                    ParamterName:"gpsStatus",
                    Value:"0"
                }
            ]
            $.ajax({
                url:baseUrlPar+'/api/AdvertApi/SaveZxbTms',
                data:{Par:encrypt1(JSON.stringify(DatePar1))},
                async:true,
                method:'post',
                error:function(r){
                },
                beforeSend: function (request) {
                    request.setRequestHeader("source", 'T9BS');
                },
                success: (res)=> {
                  if(res.Success){
                        $.javaAjax({
                        url: "/special-line-help/authorize",
                        type: "POST",
                        data:{
                          isAuth:true
                        },
                        success:  (result) =>{
                          if(result.success){
                            this.ImpowerLoginShow=false
                            this.stateImpowerLogin=false
                          }else{
                            this.$message.error(res.message);
                          }
                        },
                      })
                  }else{
                    this.$message.error(res.ErrMsg);
                  }
                }
              })
      }
    }
  }
</script>
<style scoped>
  .popupImpowerLoginContentDutton{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .popupImpowerLoginContentRight{
    width: 100%;

    position: fixed;
    flex-direction: row-reverse;
  }
  .popupImpowerLoginContent{
    overflow-y: scroll;
    height: 435px;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 14px;
  }
  .popupImpowerLogin{
    position: fixed;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index: 100;
    /* background-color: #ffffff; */
  }
  .popupImpowerHeadline{
    display: flex;
    /* justify-content:space-between; */
    flex-direction: row-reverse;
    height: 46px;
    align-items: center;
    font-size:15px;
    font-weight: bold;
  }
  .popupImpowerLoginTitle{
    display: flex;
    /* justify-content:space-between; */
    /* flex-direction: row-reverse; */
    justify-content: center;
    height: 46px;
    align-items: center;
    font-size:15px;
    font-weight: bold;
  }
  .popupImpowerClosebannerImg{
    padding-right: 20px;
    width:20px;
    height: 20px;
    z-index: 100;
  }
  .popupImpowerLoginAll{
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    overflow: hidden;
     background-color: #ffffff;
     border-radius: 8px;
    
  }
  .popupImpowerLogin .maskWin{
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    cursor: pointer;
  }
</style>